var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsaFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2961_27964)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2H16V14H0",
    fill: "#BD3D44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 3.38281H16H0ZM0 5.22531H16H0ZM0 7.07531H16H0ZM0 8.92531H16H0ZM0 10.7753H16H0ZM0 12.6253H16H0Z",
    fill: "#5C5C70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 3.38281H16M0 5.22531H16M0 7.07531H16M0 8.92531H16M0 10.7753H16M0 12.6253H16",
    stroke: "white",
    strokeWidth: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 2H9.12V8.4625H0",
    fill: "#192F5D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.666626,
    y: 2.66797,
    width: 0.666667,
    height: 0.666667,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.666626,
    y: 4.10938,
    width: 0.666667,
    height: 0.666667,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.666626,
    y: 5.55469,
    width: 0.666667,
    height: 0.666667,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.666626,
    y: 6.99609,
    width: 0.666667,
    height: 0.666667,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.02893,
    y: 6.99609,
    width: 0.666667,
    height: 0.666667,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.02893,
    y: 5.55469,
    width: 0.666667,
    height: 0.666667,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.02893,
    y: 4.10938,
    width: 0.666667,
    height: 0.666667,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.02893,
    y: 2.66797,
    width: 0.666667,
    height: 0.666667,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.39124,
    y: 6.99609,
    width: 0.666667,
    height: 0.666667,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.39124,
    y: 5.55469,
    width: 0.666667,
    height: 0.666667,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.39124,
    y: 4.10938,
    width: 0.666667,
    height: 0.666667,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.39124,
    y: 2.66797,
    width: 0.666667,
    height: 0.666667,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.75366,
    y: 6.99609,
    width: 0.666667,
    height: 0.666667,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.75366,
    y: 5.55469,
    width: 0.666667,
    height: 0.666667,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.75366,
    y: 4.10938,
    width: 0.666667,
    height: 0.666667,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.75366,
    y: 2.66797,
    width: 0.666667,
    height: 0.666667,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.11597,
    y: 6.99609,
    width: 0.666667,
    height: 0.666667,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.11597,
    y: 5.55469,
    width: 0.666667,
    height: 0.666667,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.11597,
    y: 4.10938,
    width: 0.666667,
    height: 0.666667,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.11597,
    y: 2.66797,
    width: 0.666667,
    height: 0.666667,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.47827,
    y: 6.99609,
    width: 0.666667,
    height: 0.666667,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.47827,
    y: 5.55469,
    width: 0.666667,
    height: 0.666667,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.47827,
    y: 4.10938,
    width: 0.666667,
    height: 0.666667,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.47827,
    y: 2.66797,
    width: 0.666667,
    height: 0.666667,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2961_27964"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 12,
    fill: "white",
    transform: "translate(0 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsaFlag);
export default __webpack_public_path__ + "static/media/usa-flag.5132ac0726084d07f2f103bc8a01d336.svg";
export { ForwardRef as ReactComponent };